<!-- Display breadcrumb track for the content selection display component -->
<ng-container *ngIf="breadCrumbs.length > 1">
  <p-breadcrumb [model]="breadCrumbs"></p-breadcrumb>
</ng-container>
